import { useContext } from 'react';

import { SponsorStateContext } from './SponsorContextProvider';

import SponsorData from './SponsorData';
import { DEFAULT_ID } from '@usas/ui-web/utils/Constants';

const useSponsorData = () => {
  const [sponsorState, setSponsorState] = useContext(SponsorStateContext);

  const getSponsors = async () => {
    const sponsorResultState = await SponsorData.getSponsorsData(sponsorState, setSponsorState);

    if (sponsorResultState) {
      const options = sponsorResultState.arrayData.map((x) => { return { id: x.sponsorId, name: x.sponsorName, sponsorTypeId: x.sponsorTypeId } })
      options.unshift({ id: DEFAULT_ID, name: '--', sponsorTypeId: null });

      let newState = {
        ...sponsorResultState,
        options,
        areOptionsLoaded: true
      };

      setSponsorState({ ...newState });

      return newState;
    }

    return null;
  };

  return {
    sponsorState,
    getSponsors
  };
};

export default useSponsorData;